import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import overlayFactory from 'react-bootstrap-table2-overlay';
import { useTranslation } from 'react-i18next';
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../Icons/Icons';
import { Tooltip } from "../../Utils/Tooltips";

const GroupList = ({ groups, onSelect, isLoading, editGroupButton, duplicateGroupButton }) => {
    const { t } = useTranslation();

    const columns = [
        //{ dataField: 'id', text: 'ID', sort: true },
        { dataField: 'name', text: 'Nombre del Grupo', sort: true },
        { dataField: 'description', text: 'Descripcion', sort: true },
        { dataField: 'groupsSpecialties', text: 'Especialidades', formatter: cell => (cell || []).map(item => item.description).join(', ') },
        { dataField: 'groupsProtocols', text: 'Protocolos', formatter: cell => (cell || []).length },
        { dataField: 'groupsPractitioners', text: 'Usuarios', formatter: cell => (cell || []).length },
        { dataField: 'groupsPatients', text: 'Pacientes', formatter: cell => (cell || []).length },
        { dataField: 'patientLimit', text: 'Limite pacientes por usuario', sort: true },
        { dataField: 'groupPatientLimit', text: 'Limite pacientes por grupo', sort: true },
        {
            dataField: 'actions',
            text: 'Acciones',
            formatter: (_cell, row) => (
                <>
                    {editGroupButton && (
                        React.cloneElement(editGroupButton, { group: row, buttonStyle:"general" })
                    )}
                    {editGroupButton && (
                        React.cloneElement(duplicateGroupButton, { group: row })
                    )}
                    <Tooltip tooltip={t("protocols.groups.actionView")} id={"actionView-" + row.id}>

                        <button className="btn-table-actions" onClick={() => onSelect(row)}><View /></button>
                    </Tooltip>
                    
                </>
            ),
        }
    ];


    return (
        <div>
            <BootstrapTable
                classes="table-spaced table-spaced-small"
                wrapperClasses="table-responsive"
                keyField="id"
                data={groups}
                columns={columns}
                bootstrap4
                striped
                hover
                condensed
                bordered={false}
                loading={isLoading}
                overlay={overlayFactory({ spinner: true })}
                remote
                noDataIndication={() => <>{t("commons.noData")}</>}
            />
        </div>
    );
};

export default GroupList;
